import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../config/config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function PortalLoginPage() {
  const [activeTab, setActiveTab] = useState("customer"); // "customer" or "investor"
  const [mobileNo, setMobileNo] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const endpoint =
      activeTab === "customer"
        ? `${apiKey}/portal-auth/login-customer`
        : `${apiKey}/portal-auth/login-investor`;

    axios
      .post(endpoint, {
        mobile_no: mobileNo,
        password: password,
      })
      .then((res) => {
        setLoading(false);
        const { token, user } = res.data;

        if (activeTab === "customer") {
          sessionStorage.setItem(
            "aman-customer",
            JSON.stringify({ token, user })
          );
          if (user.requiresEmailSetup) {
            toast.info("Please update your email address to secure your account.");
            navigate("/customer-panel/profile?setupEmail=true");
          } else {
            navigate("/customer-panel");
          }
        } else {
          sessionStorage.setItem(
            "aman-investor",
            JSON.stringify({ token, user })
          );
          if (user.requiresEmailSetup) {
            toast.info("Please update your email address to secure your account.");
            navigate("/investor-panel/profile?setupEmail=true");
          } else {
            navigate("/investor-panel");
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        setError(
          err.response?.data?.Error || "Invalid Credentials. Please try again."
        );
      });
  };

  return (
    <div className="container-fluid w-100 min-vh-100 bg-[#F0F3F7]">
      <ToastContainer />
      <div className="row min-vh-100 login-main">
        {/* Left branding banner */}
        <div className="left-container d-none d-lg-flex col-lg-6 justify-content-center align-items-center py-5 bg-white shadow-sm">
          <div className="text-center px-4">
            <img src="/img/background.png" alt="Portal" className="img-fluid mb-4" style={{ maxHeight: "300px" }} />
            <h1 className="loginh1 fw-bold text-primary">أمان القروض - بوابة العملاء والمستثمرين</h1>
            <p className="loginp text-muted mt-3">
              منصة الكترونية موحدة لخدمة العملاء والمستثمرين لمتابعة العقود، تقديم الطلبات، والاستعلام عن التقارير بشفافية وأمان.
            </p>
          </div>
        </div>

        {/* Right login form with tabs */}
        <div className="col-lg-6 col-md-12 d-flex justify-content-center align-items-center py-5">
          <div className="card shadow-lg border-0 col-11 col-sm-9 col-md-8 p-4 rounded-4">
            <div className="text-center mb-4">
              <img src="/img/logo.png" alt="Aman Credits" className="mb-2" style={{ maxHeight: "70px" }} />
              <h3 className="fw-bold text-dark mt-2">Portal Access</h3>
              <p className="text-muted small">Select your portal role and log in using your Mobile Number</p>
            </div>

            {/* Role Switching Tabs */}
            <div className="nav nav-pills nav-justified mb-4 p-1 bg-light rounded-3" role="tablist">
              <button
                className={`nav-link rounded-3 fw-bold py-2 ${activeTab === "customer" ? "active bg-primary text-white" : "text-dark"}`}
                onClick={() => {
                  setActiveTab("customer");
                  setError("");
                }}
                type="button"
              >
                <i className="fa fa-user me-2"></i> Customer Portal
              </button>
              <button
                className={`nav-link rounded-3 fw-bold py-2 ${activeTab === "investor" ? "active bg-primary text-white" : "text-dark"}`}
                onClick={() => {
                  setActiveTab("investor");
                  setError("");
                }}
                type="button"
              >
                <i className="fa fa-chart-line me-2"></i> Investor Portal
              </button>
            </div>

            {error && (
              <div className="alert alert-danger py-2 small mb-3 text-center" role="alert">
                {error}
              </div>
            )}

            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <label className="form-label fw-bold small text-secondary">
                  Mobile Number / National ID
                </label>
                <div className="input-group">
                  <span className="input-group-text bg-white">
                    <i className="fa fa-phone text-muted"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control form-control-lg fs-6"
                    placeholder="Enter your Mobile Number or ID"
                    value={mobileNo}
                    onChange={(e) => setMobileNo(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label fw-bold small text-secondary">Password</label>
                <div className="input-group">
                  <span className="input-group-text bg-white">
                    <i className="fa fa-lock text-muted"></i>
                  </span>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control form-control-lg fs-6"
                    placeholder="Enter password (default: 12345678)"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                  </button>
                </div>
                <div className="form-text small text-end mt-1">
                  Default initial password: <code>12345678</code> or Mobile Number
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-primary btn-lg w-100 fw-bold shadow-sm"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Logging in...
                  </>
                ) : (
                  `Log In as ${activeTab === "customer" ? "Customer" : "Investor"}`
                )}
              </button>
            </form>

            <div className="text-center mt-4">
              <a href="/" className="text-muted small text-decoration-none">
                <i className="fa fa-arrow-left me-1"></i> Back to Branch / Admin Login
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PortalLoginPage;
